import React, { useEffect, useRef } from "react"
// @ts-ignore
import canvasDatagrid from "canvas-datagrid"

const Sheet: React.FC<{ sheetContent: object }> = ({ sheetContent }) => {
    const gridRef = useRef<any>(null)

    useEffect(() => {
        if (gridRef.current && sheetContent) {
            gridRef.current.data = sheetContent
        }
    }, [sheetContent])

    return (
        <div
            style={{
                height: "100%",
                width: "100%",
                overflowY: "scroll",
                paddingBottom: "100px",
                background: "var(--white)",
            }}
            ref={(el) => {
                if (el && !gridRef.current) {
                    gridRef.current = canvasDatagrid({
                        parentNode: el,
                        editable: true,
                        allowColumnResize: true,
                        allowRowResize: true,
                        autoResizeColumns: true,
                        autoResizeRows: true,
                    })
                }
            }}></div>
    )
}

export default Sheet
